// export const FETCH_HOTEL_REQUEST = "FETCH_HOTEL_REQUEST";
// export const FETCH_HOTEL_SUCCESS = "FETCH_HOTEL_SUCCESS";
// export const FETCH_HOTEL_FAILURE = "FETCH_HOTEL_FAILURE";
export const FETCH_HOTEL_REQUEST = "FETCH_HOTEL_REQUEST";
export const FETCH_HOTEL_SUCCESS = "FETCH_HOTEL_SUCCESS";
export const FETCH_HOTEL_FAILURE = "FETCH_HOTEL_FAILURE";

export const CREATE_HOTEL_REQUEST = "CREATE_HOTEL_REQUEST";
export const CREATE_HOTEL_SUCCESS = "CREATE_HOTEL_SUCCESS";
export const CREATE_HOTEL_FAILURE = "CREATE_HOTEL_FAILURE";

export const UPDATE_HOTEL_REQUEST = "UPDATE_HOTEL_REQUEST";
export const UPDATE_HOTEL_SUCCESS = "UPDATE_HOTEL_SUCCESS";
export const UPDATE_HOTEL_FAILURE = "UPDATE_HOTEL_FAILURE";

export const DELETE_HOTEL_REQUEST = "DELETE_HOTEL_REQUEST";
export const DELETE_HOTEL_SUCCESS = "DELETE_HOTEL_SUCCESS";
export const DELETE_HOTEL_FAILURE = "DELETE_HOTEL_FAILURE";
